import React, { useRef, useEffect, ReactElement } from 'react'
import {
  VARIANT_COMBO,
  VARIANT_STAR,
} from '@mindfulchefuk/features/Onboarding/components/TrustpilotMicroCombo/constants'

const variants = {
  combo: VARIANT_COMBO,
  star: VARIANT_STAR,
}

/**
 * @see https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-Overview#micro-combo-5
 */

export const TrustpilotMicroCombo = ({
  variant = 'combo',
}: {
  variant?: keyof typeof variants
}): ReactElement => {
  const ref = useRef(null)

  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the
    // TrustPilotMicroCombo from our ref.
    // If it's not, it means the script in <head /> isn't loaded just yet.
    // When it is, it will automatically load the TrustpilotMicroCombo.
    if ((window || {}).Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (
    <div
      ref={ref} // Reference this element to load the TrustpilotMicroCombo in the effect
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id={variants[variant]}
      data-businessunit-id="563ca4940000ff000585374b"
      data-style-height="20px"
      data-style-width="100%"
      data-font-size="40px"
      data-theme="light"
    />
  )
}
